// Modules
import React from 'react';
import { inject, observer } from 'mobx-react';

// Material-UI
import Typography from 'material-ui/Typography';
import Input, { InputLabel } from 'material-ui/Input';
import { MenuItem } from 'material-ui/Menu';
import Select from 'material-ui/Select';
import { FormControl } from 'material-ui/Form';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import List, {
  ListItem,
  // ListItemSecondaryAction,
  ListItemText,
} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import PinIcon from 'material-ui-icons/Place';

// Components
import PageChrome from '../PageChrome';

// Styles
import './style.css';

@inject('AuthStore', 'PinStore')
@observer
export default class extends React.Component {
  componentDidMount() {
    this.props.PinStore.getPins();

    // Add Goolge Places Autocomplete
    const autocompleteFormField = document.getElementById('location-autocomplete');
    const autocomplete = new window.google.maps.places.Autocomplete((autocompleteFormField), {
      country: ['us'],
    });
    window.google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const location = autocomplete.getPlace();
      const { PinStore } = this.props;
      PinStore.pinItem.locationId = location.place_id;
      PinStore.pinItem.name = location.name;
      PinStore.pinItem.lat = location.geometry.location.lat();
      PinStore.pinItem.lng = location.geometry.location.lng();
    });
  }

  componentWillUnmount() {
    this.props.PinStore.unsubscribe();
    this.props.PinStore.resetPinItem();
  }

  render() {
    const {
      PinStore,
    } = this.props;

    const {
      pinItem,
      pinList,
    } = PinStore;

    return (
      <PageChrome
        {...this.props}
        title="Pins"
      >
        <Grid container>
          <Grid item xs={12} lg={6}>
            <Typography type="headline" style={{ marginTop: 24, marginBottom: 24 }}>
              {PinStore.editMode ? 'Edit Pin' : 'New Pin'}
            </Typography>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  id="location-autocomplete"
                  className="input"
                  label="Location Search"
                  type="text"
                  fullWidth
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  className="input"
                  label="Pin Name"
                  value={pinItem.name}
                  onChange={(e) => { PinStore.pinItem.name = e.target.value; }}
                  margin="normal"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth margin="normal">
                  <InputLabel htmlFor="pinCategory">Category</InputLabel>
                  <Select
                    value={pinItem.category}
                    onChange={(e) => { PinStore.pinItem.category = e.target.value; }}
                    input={<Input name="pinCategory" id="pin-category" />}
                  >
                    <MenuItem value="Water/Waste Water">Water/Waste Water</MenuItem>
                    <MenuItem value="Competitor">Competitor</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  className="input"
                  label="Latitude"
                  value={pinItem.lat}
                  onChange={(e) => { PinStore.pinItem.lat = e.target.value; }}
                  margin="normal"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  className="input"
                  label="Longitude"
                  value={pinItem.lng}
                  onChange={(e) => { PinStore.pinItem.lng = e.target.value; }}
                  margin="normal"
                  fullWidth
                />
              </Grid>
            </Grid>
            {!PinStore.editMode ?
              <Button
                raised
                color="primary"
                style={{ marginTop: 24 }}
                onClick={() => {
                  PinStore.createPin();
                  const locationSearch = document.getElementById('location-autocomplete');
                  locationSearch.value = '';
                }}
                disabled={!pinItem.name || !pinItem.lat || !pinItem.lng || !pinItem.category}
              >
                Save
              </Button> :
              <div className="edit-button-container">
                <Button
                  raised
                  color="primary"
                  style={{ marginTop: 24, marginRight: 24 }}
                  onClick={() => {
                    PinStore.updatePin();
                    const locationSearch = document.getElementById('location-autocomplete');
                    locationSearch.value = '';
                  }}
                  disabled={!pinItem.name || !pinItem.lat || !pinItem.lng || !pinItem.category}
                >
                  Update
                </Button>
                <Button
                  raised
                  color="accent"
                  style={{ marginTop: 24, marginRight: 24 }}
                  onClick={() => {
                    PinStore.deletePin();
                    const locationSearch = document.getElementById('location-autocomplete');
                    locationSearch.value = '';
                  }}
                >
                  Delete
                </Button>
                <Button
                  raised
                  style={{ marginTop: 24 }}
                  onClick={() => {
                    PinStore.cancelEdit();
                    const locationSearch = document.getElementById('location-autocomplete');
                    locationSearch.value = '';
                  }}
                >
                  Cancel
                </Button>
              </div>
            }
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography type="headline" style={{ marginTop: 24, marginBottom: 24 }}>Pins</Typography>
            <List>
              {pinList.map(p => (
                <ListItem
                  key={p.id}
                  button
                  onClick={() => PinStore.editPinItem(p, p.id)}
                >
                  <Avatar>
                    <PinIcon />
                  </Avatar>
                  <ListItemText primary={p.name} secondary={p.category} />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
      </PageChrome>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pins/index.js